import makeEMediaModule from '@/store/eMediaModule';
import * as eMediaService from '@/services/services/documentsService';
import BaseModulePlugins from '@/store/baseModule/plugins';

export default (store) => {
  store.registerModule(
    'documents',
    makeEMediaModule({
      sortChoices: ['last_update_datetime'],
      eMediaService,
      paramId: 'propertyId',
    })
  );

  const basePlugin = new BaseModulePlugins({
    paramId: 'propertyId',
    module: 'documents',
    store,
  });

  basePlugin.onInit(() => {
    store.dispatch('documents/loadCategories');

    store.subscribe((mutation) => {
      if (
        mutation.type === 'properties_360/SET_CURRENT_REQUEST' &&
        mutation.payload
      ) {
        store.dispatch('documents/loadPropertyItems', {
          propertyId: mutation.payload,
        });
      }
    });

    store.subscribe((mutation) => {
      if (
        mutation.type === 'actionplans/actions/SET_CURRENT' &&
        mutation.payload
      ) {
        store.dispatch('documents/loadActionItems', {
          actionId: mutation.payload.id,
          propertyId: mutation.payload.node_associated_id,
          propertyCode: mutation.payload.node_associated_code,
        });
      }
    });
  });
};
